import React, { useContext } from "react";

import { Grid, Grow } from "@material-ui/core";
import TextField from "../../../../components/basics/TextFieldErp";

import { EmissaoContext } from "../contexts/EmissaoContext";

const TabEmissaoObservacoes = ({ ...props }) => {
  const {
    obsTextCreditRate,
    setObsTextCreditRate,
    obsTextCFOP,
    setObsTextCFOP,
    obsTextComplemento,
    setObsTextComplemento,
    consideraObsCredit,
  } = useContext(EmissaoContext);

  return (
    <Grow in={true}>
      <Grid container spacing={2}>
        <Grid item lg={12} sm={12}>
          <TextField
            value={obsTextCFOP}
            setValue={setObsTextCFOP}
            label="Observações CFOP"
            multiline
            variant="filled"
          />
        </Grid>
        {consideraObsCredit ? (
          <Grid item lg={12} sm={12}>
            <TextField
              value={obsTextCreditRate}
              setValue={setObsTextCreditRate}
              label="Observação de Permissão de Crédito de ICMS"
              multiline
              variant="filled"
            />
          </Grid>
        ) : (
          <></>
        )}
        <Grid item lg={12} sm={12}>
          <TextField
            value={obsTextComplemento}
            setValue={setObsTextComplemento}
            label="Observações Complementares"
            multiline
            minRows={6}
            variant="filled"
          />
        </Grid>
      </Grid>
    </Grow>
  );
};

export default TabEmissaoObservacoes;
